import {TextSearchFilterComponent} from './text-search-filter/text-search-filter.component';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {CacheDataService} from '../../api/services/cache-data.service';
import {AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, forwardRef, Input, NgZone, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import {CdkVirtualScrollViewport} from '@angular/cdk/scrolling';
import {Title} from '../../api/models/title';
import {CleanLocation} from '../../api/models/clean-location';
import {Company} from '../../api/models/company';

@Component({
  selector: 'location-search',
  templateUrl: './text-search-filter/text-search-filter.component.html',
  styleUrls: ['./text-search-filter/text-search-filter.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LocationSearchComponent),
      multi: true
    }
  ]
})
export class LocationSearchComponent extends TextSearchFilterComponent<CleanLocation> implements ControlValueAccessor, OnInit, AfterViewInit
{
  @ViewChild('scrollDiv') scrollDiv : ElementRef;
  @Input() fixedHeight?: number;
  @Input() showSelected: boolean = false;

  constructor(cacheDataService: CacheDataService, ngZone: NgZone) {
    super(cacheDataService, ngZone);
  }

  dataUpdated(): void {}

  protected getShowSelected(): boolean {
    return this.showSelected;
  }

  protected getHeightValue() : number | undefined {
    if (this.fixedHeight) {
      return this.fixedHeight;
    }
    return undefined;
  }

  ngOnInit() {
    this.callNgOnInit();
  }

  ngAfterViewInit() {
    this.callNgAfterViewInit();
  }

  protected getDivScroller(): ElementRef {
    return this.scrollDiv;
  }

  protected isSelected(target: CleanLocation) : boolean {
    const exists = this._value && this._value.selectedValues && this._value.selectedValues.find(x => x.key === target.key);
    return !!exists;

  }

  protected getDisplay(target: CleanLocation): string {
    if (!target.stateProvinceRegion || target.stateProvinceRegion.length === 0) {
      return target.countryIso + ' - <NONAME>';
    } else {
      return target.countryIso + ' - ' + target.stateProvinceRegion + ' - ' + target.city;
    }
  }

  protected newSearch() {
    this.reloading = true;
    this.cacheDataService.cacheDataSearchCleanLocations({
      pageNumber: 1,
      pageSize: 100,
      locationSearch: this.value?.searchTerms ?? []
    }).subscribe(result => {
      this.currentPage = 1;
      this.totalPages = result.totalPages;
      this.sourceValues = result.page;
      this.reloading = false;
    });
  }
  protected getNextBatch() {
    if (this.currentPage < this.totalPages) {
      this.loading = true;
      this.currentPage++;
      this.cacheDataService.cacheDataSearchCleanLocations({
        pageNumber: this.currentPage,
        pageSize: 100,
        locationSearch: this._value?.searchTerms ?? [],
      }).subscribe(result => {
        this.totalPages = result.totalPages;
        this.loading = false;
        this.sourceValues = [...this.sourceValues, ...result.page];
      });
    }
  }

  protected getSearchPlaceholder(): string {
    return 'Location / Country Keyword...';
  }
}
